import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';

import { AppState } from './store/models/app.state';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { loadSettings } from './store/actions/settings.actions';
import { APP_ICONS } from './app.icons';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_LANG, SUPPORTED_LANGS } from './core/config/languages';
import { ConfirmComponent } from './shared/confirm/confirm.component';
import { ToastModule } from '@openng/optimus-ui/toast';

@Component({
  selector: 'phar-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, ConfirmComponent, ToastModule],
})
export class AppComponent implements OnInit {
  private store: Store<AppState> = inject(Store);
  private domSanitizer: DomSanitizer = inject(DomSanitizer);
  private matIconRegistry: MatIconRegistry = inject(MatIconRegistry);
  private translate: TranslateService = inject(TranslateService);

  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    // Initialize translate service
    this.translate.addLangs(SUPPORTED_LANGS);
    this.translate.use(DEFAULT_LANG);


    this.registerCustomMaterialIcons();
    this.store.dispatch(loadSettings());
  }

  registerCustomMaterialIcons() {
    APP_ICONS.forEach(iconName => {
      this.matIconRegistry.addSvgIcon(
        iconName,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`./assets/icons/${iconName}.svg`),
      );
    });
  }
}
